<template>
  <MainLayout page-name="fees-for-paid-passengers-master">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="preparation" @click="clickPreparation">料金マスタ準備</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
        @clear="clickClear"
        category="master"
      >
        <ChargeYear v-model="simpleSearchFormModel.charge_year" ref="childChargeYear" label="料金年度" prop="charge_year" :searchCond="true" :initialize="true" :required="true" tableType="PAID_PASSENGERS" yearType = "reference" mode = "this" selectedIndex="0"/>
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :default-sort="{ prop: 'route_code', order: 'descending' }"
      :selectable="deletable"
      :multi-select="false"
      @row-click="clickRow"
      class="fees-for-paid-passengers-master-table"
    >
      <template #columns>
        <RouteCodeColumn />
        <TextMiddleColumn label="ジェット区分" prop="jet_type_name" class-name="jet-type-name" />
        <TextMiddleColumn label="有償区分" prop="paid_type_name" />
        <DateTimeColumn label="更新日時" prop="updated_on" />
        <BlankColumn />
      </template>
    </Table>
    <FeesForPaidPassengersMasterPreparationDialog
      :visible.sync="preparationDialogVisible"
      @refresh="refreshSearch"
    />
    <FeesForPaidPassengersMasterEditDialog
      :visible.sync="editDialogVisible"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import ChargeYear from '@/components/molecules/form/select/ChargeYear.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import RouteCodeColumn from '@/components/molecules/table/RouteCodeColumn.vue'
import TextMiddleColumn from '@/components/molecules/table/TextMiddleColumn.vue'
import DateTimeColumn from '@/components/molecules/table/DateTimeColumn.vue'

import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
import FeesForPaidPassengersMasterPreparationDialog from '@/components/pages/feeMaster/feesForPaidPassengersMaster/FeesForPaidPassengersMasterPreparationDialog.vue'
import FeesForPaidPassengersMasterEditDialog from '@/components/pages/feeMaster/feesForPaidPassengersMaster/FeesForPaidPassengersMasterEditDialog.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    ChargeYear,
    SimpleSearch,
    Table,
    RouteCodeColumn,
    TextMiddleColumn,
    DateTimeColumn,
    BlankColumn,
    FeesForPaidPassengersMasterPreparationDialog,
    FeesForPaidPassengersMasterEditDialog
  },
  mixins: [
  ],
  data () {
    return {
      title: '着陸料金マスタ[有償旅客]',
      tableData: [],
      simpleSearchFormModel: {
        charge_year: ''
      },
      currentRow: {},
      preparationDialogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('feesForPaidPassengersMasterSearchCond')
  },
  methods: {
    clickPreparation () {
      this.preparationDialogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('feesForPaidPassengersMasterSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    clickClear () {
      this.$set(this.simpleSearchFormModel, 'charge_year', this.$refs.childChargeYear.options[0].value)
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('feesForPaidPassengersMasterSearchCond'))
      this.$axios
        .get('/search-fees-for-paid-passengers-master', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch (chargeYear) {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForPaidPassengersMasterSearchCond'))
      if (!searchCond) {
        this.$set(this.simpleSearchFormModel, 'charge_year', chargeYear)
        sessionStorage.setItem('feesForPaidPassengersMasterSearchCond', JSON.stringify(this.simpleSearchFormModel))
      } else {
        this.$set(this.simpleSearchFormModel, 'charge_year', searchCond.charge_year)
      }

      this.search()
    },
    csvDataFormatter (row) {
      const result = { ...row }
      delete result.update_on
      result.start_date += ' 00:00:00'
      result.end_date += ' 00:00:00'
      return result
    },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.fees-for-paid-passengers-master-table {
  ::v-deep .table-wrapper-inner {
    .el-table {
      table {
        th,
        td {
          &.jet-type-name {
            width: 12rem;
          }
        }
      }
    }
  }
}
.dummy {
  display: none;
}
</style>
